import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import ReactLoading from 'react-loading';
import Modal from '../Modal';
import './MainPage.scss';
import BACK_URL from '../../const';
import Button from '../shared/Button';
import Input from '../shared/Input';
import Header from '../Header';
import Footer from '../Footer';

const MainPage = () => {

    const [isLoading, setIsLoading] = useState(false)
    const [itens, setItens] = useState([])
    const [pedidos, setPedidos] = useState([])
    const [carrinho, setCarrinho] = useState([])
    const [isFinalModalOpen, setIsFinalModalOpen] = useState(false)
    const [userName, setUserName] = useState('')
    const [checkbox, setCheckbox] = useState(false)
    const [anosJulia, setAnosJulia] = useState(10)
    const [mensagemJulia, setMensagemJulia] = useState('')
    const [isMessageModalOpen, setIsMessageModalOpen] = useState(false)


    useEffect(() => {
        load()
    }, [])

    const load = (showInfo = true) => {
        setIsLoading(true)
        fetch(`${BACK_URL}/search?`)
        .then((res) => {
            if(res.status !== 200) {
                throw(new Error("Something went wrong!"))
            }
            return res.json()
        })
        .then((res) => {
            setItens(res.itens);
            setPedidos(res.pedidos);
            if(showInfo)
                toast.success(`O site está pronto!`)
        })
        .catch((e) => {
            toast.error(e)
            console.log(`error = ${e}`)
        })
        .finally(() => {
            setIsLoading(false)
        })
    }

    const criarPedido = () => {
        const payload = {
            idItem: carrinho.id,
            nomeComprador: userName,
            anoJulia: checkbox ? anosJulia : undefined,
            mensagemJulia: checkbox ? mensagemJulia : ''
        }

        setIsLoading(true)
        fetch(`${BACK_URL}/criarPedido`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(payload)
        })
        .then((res) => {
            if(res.status !== 200) {
                throw(new Error("Something went wrong!"))
            }
            return res.json()
        })
        .then(() => {
            setIsFinalModalOpen(false)
            toast.success(`Tudo gravado! Muito obrigado!`);
            setIsMessageModalOpen(true)
        })
        .catch((e) => {
            toast.error(e)
            console.log(`error = ${e}`)
        })
        .finally(() => {
            setIsLoading(false)
        })
    }

    const addCarrinho = (item) => {
        if(howManyPedidos(item.id) < item.qtd) {
            setCarrinho(item)
            setIsFinalModalOpen(true)
        }
    }

    const howManyPedidos = (itemId) => {
        if(!pedidos) {
            return 0
        }
        const res = pedidos.map(p => p.idItem).filter(p => p === itemId).length
        
        return res
    }

    const renderSets = () => {
        return itens.map(element => {
            return (
        <div className={`item ${howManyPedidos(element.id) >= element.qtd ? 'disabled' : ''}`} key={element.id}>
            <div className='item-image'>
                <img src={element.imageUrl} alt='foto' width={100} height={100} />
            </div>
            <div className='item-name'>
                {element.name}
            </div>
            <div className='item-button'>
                <Button disabled={howManyPedidos(element.id) >= element.qtd} onClick={() => addCarrinho(element)}>escolher esse!</Button>
            </div>
        </div>  
        )})
    }

    const restartAll = () => {
        load()
        setCheckbox(false)
        setAnosJulia(10)
        setMensagemJulia('')
    }

    return (
        <>
            <Header />
            <div className={`main-container`}>
                <Modal open={isLoading}>
                    <ReactLoading type={"spin"} color="#ECB3B9" />
                </Modal>
                <Modal open={isFinalModalOpen}>
                    <div style={{marginBottom: '20px', fontSize: '20px'}}>
                        <span>Você quer se identificar?</span>
                        <Input label='' value={userName} onChange={(e) => setUserName(e.target.value)} />
                    </div>
                    <div style={{marginBottom: '20px', fontSize: '20px'}}>
                        <span>Você quer mandar uma mensagem para a Júlia?</span>
                        <input type='checkbox' value={checkbox} onChange={(e) => setCheckbox(e.target.checked)} style={{width: '20px', height: '20px', marginLeft: '8px'}} />
                    </div>
                    {checkbox ? 
                        <>
                            <div style={{marginBottom: '20px'}}>
                                <span style={{fontSize: '20px'}}>Quer mandar a mensagem pra Júlia de quantos anos?</span>
                                <Input type='number' label='' value={anosJulia} onChange={(e) => setAnosJulia(e.target.value)} />
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                                <span style={{marginBottom: '6px', fontSize: '20px'}}>Escreva sua mensagem!</span>
                                <textarea value={mensagemJulia} onChange={(e) => setMensagemJulia(e.target.value)} />
                            </div>
                        </>
                        :
                        <></>}
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <Button onClick={() => setIsFinalModalOpen(false)}>Cancelar</Button>
                        <Button onClick={() => criarPedido()}>Finalizar!</Button>
                    </div>
                </Modal>
                <Modal open={isMessageModalOpen}>
                    <div className='modalFinalMessage'>
                        <span>Agradecemos por fazer parte deste momento tão especial e por todo o carinho com a Júlia! </span>
                        <span>Nos vemos em breve! ❤️</span>
                        <Button style={{alignSelf: 'center', width: 'fit-content'}} onClick={() => {setIsMessageModalOpen(false); restartAll()}}>Quero continuar vendo!</Button>
                    </div>
                </Modal>
                <div className={`item-container`}>
                    {renderSets()}
                </div>
            </div>
            <Footer />
        </>
    )
}

export default MainPage;